import React, { useRef, useState, useEffect } from 'react'
import profile from '../assets/Admin/profile.jpg'
import { MdError } from 'react-icons/md'
import { useNavigate, useLocation } from 'react-router-dom';
import { getCookie } from '../components/Helper/Helpers'
import { getParticularReferralAgentDetails, manageReferralUsers, createNewReferralUser } from '../serverApi/server'


const Referral = () => {
  const [contentSwitch, setContentSwitch] = useState('personal-info')
  const location = useLocation();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState();
  const [manageReferrls, setManageReferrals] = useState([]);
  const [appliedReferrls, setAppliedReferrls] = useState([]);

  // const userId = getCookie('_uisap');
  // console.log('\n userId ---------------->:', userId)

  const getCurrentReferralUserDetails = async (userId) => {
    const getParticularReferralAgentDetailsAPIResponse = await getParticularReferralAgentDetails(userId)
    setUserDetails(getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer)
  }

  const manageReferralUsersDetails = async (userId) => {
    const manageReferralUsersAPIResponse = await manageReferralUsers(userId)
    setManageReferrals(manageReferralUsersAPIResponse.data.send_referral_users_serializer);
    setAppliedReferrls(manageReferralUsersAPIResponse.data.order_referral_users_details);
  }

  useEffect(() => {
    const userId = getCookie('_puisap');
    if (userId) {
      getCurrentReferralUserDetails(userId);
      manageReferralUsersDetails(userId);
    }
  }, []);

  const buttons = [
    {id: 1, name: 'Personal Information', additionalName: 'personal-info'},
    // {id: 2, name: 'Send Referral', additionalName: 'send-ref'},
    // {id: 3, name: 'Manage Referrals', additionalName: 'manage-ref'},
    {id: 4, name: 'Referrals Applied', additionalName: 'ref-applied'}
  ]

  const sendRefInputs = [
    {id: 1, name: "Referral's Name", additionalName: 'refName', type: 'text'},
    {id: 2, name: "Referral's Phone Number", additionalName: 'refPho', type: 'number'},
    {id: 3, name: "Referral's Email", additionalName: 'refEmail', type: 'email'}
  ]

  const refs = {
    refName: useRef(),
    refPho: useRef(),
    refEmail: useRef()
  };

  const [sendRef, setSendRef] = useState({
    refName: '',
    refPho: '',
    refEmail: ''
  });

  const [errors, setErrors] = useState({})

  const handleSendRef = (e) => {
    const { name, value } = e.target
    setSendRef(prev => ({
      ...prev,
      [name]: value
    }))
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }))
  }
  
  const checkOnBlur = (e) => {
    const { name, value } = e.target
    let msg = null
    if (name === 'refName') {
      if (value === '') {
        msg = 'Enter your name';
      } else if (value.length < 3) {
        msg = 'Name must have more than 3 letters';
      }
    }
    if (name === 'refPho') {
      if (value === '') {
        msg = 'Enter your name';
      } else if (value.length < 10) {
        msg = 'Phone number must be at least 10 digits.';
      }
    }
    if (name === 'refEmail') {
      if (value === '') {
        msg = 'Enter your email';
      } else if (!/\S+@\S+\.\S+/.test(value)) {
        msg = 'Valid email is required.';
      }
    }
  
    setErrors(prev => ({
      ...prev,
      [name]: msg
    }));
  }

  const [errorResponse, setErrorResponse] = useState('')
  const [successResponse, setSuccessResponse] = useState('')
  const [successResponsePopup, setSuccessResponsePopup] = useState(false)

  const sendReferralCode = async () => {
    const createNewReferralUserAPIResponse = await createNewReferralUser(userDetails.user, sendRef.refName, sendRef.refPho, sendRef.refEmail)
    if (createNewReferralUserAPIResponse.data && createNewReferralUserAPIResponse.data.client_status_code == 200) {
      setSendRef({
        refName: '',
        refPho: '',
        refEmail: ''
      })
      setErrors({})
      manageReferralUsersDetails(userDetails.user);
      setSuccessResponse(createNewReferralUserAPIResponse.data.message)
      setSuccessResponsePopup(true)
      setTimeout(()=>{
        setSuccessResponsePopup(false)
      }, 3000)
    } else if (createNewReferralUserAPIResponse.data) {
      setErrorResponse(createNewReferralUserAPIResponse.data.message)
    }

  }

  return (
    <main className='w-full min-h-screen bg-[#EFEEF3] flex justify-center items-center'>
      <section className='w-full sm:w-4/5 md:w-full lg:w-4/5 flex flex-col items-center md:flex-row md:items-stretch md:justify-center gap-4 px-5 md:px-8 lg-px-0 py-5'>
        <div className='w-full md:w-[30%] bg-white rounded-lg flex flex-col justify-between md:items-center md:justify-start gap-2 min-[510px]:gap-4 md:p-4 lg:p-5'>
          {userDetails && (
            <div className='flex flex-col border-r-2 rounded-r-lg border-neutral-300 md:border-none  items-center gap-4 p-4'>
              <img src={profile} alt="profile" className='w-20 h-20 rounded-full object-cover object-center border[0.5px] border-neutral-200'/>
              <div className='text-center text-neutral-700'>
                <h3 className='text-lg font-medium'>{userDetails.full_name}</h3>
                <p className='text-[15px] whitespace-nowrap'>Referral Code: <span className='text-neutral-600 font-light'>{userDetails.referral_code}</span></p>
              </div>
            </div>
          )}
          <div className='w-full flex flex-col items-start p-4 gap-3'>
            {buttons.map(btn => (
            <button type="button" key={btn.id} className={`max-[510px]:w-full w-3/4 md:w-full px-2 py-2 md:px-3 rounded-xl text-white bg-orange-500 hover:bg-orange-600 ${contentSwitch === btn.additionalName && 'underline underline-offset-4'}`} onClick={() => setContentSwitch(btn.additionalName)}>{btn.name === 'Personal Information' ? (<> <span className='lg:hidden'>Personal-info</span> <span className='hidden lg:inline'>{btn.name}</span> </>) : btn.name}</button>
            ))}
          </div>
        </div>
        <div className='w-full md:w-[70%] bg-white flex-1 rounded-lg p-4 lg:p-5'>
          {userDetails && contentSwitch === 'personal-info' && (
            <section className='w-full text-neutral-700 flex flex-col gap-4'>
              <h2 className='text-xl font-semibold'>Personal Information</h2>
              <div className='w-full overflow-x-auto'>  
                <table className='min-w-full w-full lg:text-[17px]'>
                  <tbody>
                    <tr className='min-w-full w-full border'>
                      <td className='min-w-max bg-neutral-200 font-medium px-2 py-2'>Name</td>
                      <td className='px-2 py-2'>{userDetails.full_name}</td>
                    </tr>
                    <tr className='border'>
                      <td className='bg-neutral-200 font-medium px-2 py-2'>Email</td>
                      <td className='px-2 py-2'>{userDetails.email}</td>
                    </tr>
                    <tr className='border'>
                      <td className='bg-neutral-200 font-medium px-2 py-2'>Phone</td>
                      <td className='px-2 py-2'>{userDetails.phone_number}</td>
                    </tr>
                    <tr className='border'>
                      <td className='bg-neutral-200 font-medium px-2 py-2'>Role</td>
                      <td className='px-2 py-2'>{userDetails.role === 'referral'? 'Referral Agent' : ''}</td>
                    </tr>
                    <tr className='border'>
                      <td className='bg-neutral-200 font-medium px-2 py-2'>Referral Code</td>
                      <td className='px-2 py-2'>{userDetails.referral_code}</td>
                    </tr>
                    <tr className='border'>
                      <td className='bg-neutral-200 font-medium px-2 py-2'>Discount %</td>  
                      <td className='px-2 py-2'>{userDetails.agent_discount} %</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          )}
          {contentSwitch === 'send-ref' && (
            <section className='text-neutral-700 bg-[#EFEEF3]/70 rounded-md flex flex-col gap-2 p-4'>
              <h2 className='text-xl font-semibold'>Send Referral</h2>
              <div className='flex flex-col gap-2 mt-1'>
                {sendRefInputs.map(inp => (
                <div className="relative w-full">
                  <label
                    htmlFor={inp.additionalName}
                    className='cursor-text left-2 min-[500px]:left-3 md:left-[14px] text-neutral-700 md:text-[17px] text-[15px] sm:text-base transform transition-all duration-100'
                  >
                    {inp.name} *
                  </label>
                  <input
                    type={inp.type}
                    name={inp.additionalName}
                    id={inp.additionalName}
                    onBlur={checkOnBlur}
                    ref={refs[inp.additionalName]}
                    value={sendRef[inp.additionalName]}
                    onChange={handleSendRef}
                    className={`w-full px-4 py-2 border ${errors[inp.additionalName] ? 'border-[#B3261E] outline-[#B3261E]' : 'border-neutral-500 outline-[#FDCFA8]'} rounded outline-2 outline-opacity-0 focus:outline-opacity-100 transform transition-opacity duration-500`}
                  />
                  {errors[inp.additionalName] && (
                    <label
                    htmlFor={inp.additionalName}
                      className={`absolute right-4 text-xl text-red-700 transform transition-all duration-100 translate-y-3 min-[500px]:translate-y-[12px]`}
                    >
                      <MdError />
                    </label>
                  )}
                  {errors[inp.additionalName] && (
                    <p className="text-red-700 px-2 text-sm duration-500">{errors[inp.additionalName]}</p>
                  )}
                  
                </div>
                ))}
              </div>
              {errorResponse && <p className="text-red-700 px-2 text-sm duration-500">{errorResponse}</p>}
              {successResponsePopup && <p className="text-green-700 px-2 text-sm duration-500">{successResponse}</p>}
              <button type="button" onClick={sendReferralCode} className={`self-start mt-1 px-3 py-2 rounded text-white bg-orange-500 hover:bg-orange-600`}>Send Referral</button>
            </section>
          )}
          {contentSwitch === 'manage-ref' && (
            <section className='text-neutral-700 flex flex-col gap-4'>
              <h2 className='text-xl font-semibold'>Manage Referrals</h2>
              <div className='overflow-x-auto'>
                <table className='lg:text-[17px]'>
                  <thead>
                    <tr className='bg-neutral-200 font-medium'>
                      <th className='border-r border-white text-start px-2 py-2'>Referral's Name</th>
                      <th className='border-r border-white text-start px-2 py-2'>E-mail</th>
                      <th className='text-start px-2 py-2'>Referral Send Date</th>
                    </tr>
                  </thead>
                  <tbody>
                  {manageReferrls.length > 0 ? (
                    manageReferrls.map((referral, index) => (
                      <tr className='border'>
                        <td className='border px-2 py-2'>{referral.name}</td>
                        <td className='border px-2 py-2'>{referral.email}</td>
                        <td className='border px-2 py-2'>{new Date(referral.created_at).toLocaleDateString("en-US")}</td>
                      </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="px-4 py-6 text-center text-neutral-600">
                          No referral users available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </section>
          )}
          {contentSwitch === 'ref-applied' && (
            <section className='text-neutral-700 flex flex-col gap-4'>
              <h2 className='text-xl font-semibold'>Referrals Applied</h2>
              <div className='overflow-x-auto'>
                <table className='lg:text-[17px]'>
                  <thead>
                    <tr className='bg-neutral-200 font-medium'>
                      <th className='border-r border-white text-start px-2 py-2 '>Referral's Name</th>
                      <th className='border-r border-white text-start px-2 py-2'>E-mail</th>
                      <th className='border-r border-white text-start px-2 py-2'>Total Amount</th>
                      <th className='text-start px-2 py-2'>Commission Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appliedReferrls.length > 0 ? (
                      appliedReferrls.map((referral, index) => (
                        <tr className='border'>
                          <td className='border px-2 py-2'>{referral.customer_name}</td>
                          <td className='border px-2 py-2'>{referral.customer_email}</td>
                          <td className='border px-2 py-2'>{parseFloat(referral.total_amount).toFixed(2)}</td>
                          <td className='border px-2 py-2'>{parseFloat(referral.agent_discount_amount).toFixed(2)}</td>
                        </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="px-4 py-6 text-center text-neutral-600">
                            No referral users available.
                          </td>
                        </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </section>
          )}
        </div>
      </section>
    </main>
  )
}

export default Referral
